import 'css-chunksrc/client/scenes/project/nameForm/styles.scss';export default {
  "nameForm": "_nameForm_keb0q_1",
  "title": "_title_keb0q_5",
  "input": "_input_keb0q_11"
};